<template>
	<el-card class="paymentbox" shadow="never">
		<div slot="header" class="clearfix flex" style="align-items: baseline">
			<h3>付款详情</h3>
			<span style="color: #505259; font-size: 14px; margin-left: 12px">共{{ totalNum }}件商品</span>
		</div>

		<div class="pay-detail" style="margin-bottom: 20px; line-height: 28px">
			<!-- 没有额外商品 -->
			<div v-if="!hasElseProduct" class="noHas-extra-goods">
				<p style="margin-bottom: 10px">
					订单总金额：<em style="color: #ff5722; font-size: 20px; font-weight: 600">{{ hasPaperProduct ? (totalChecked + shippingCost).toFixed(2) : totalChecked.toFixed(2) }} 元</em>
				</p>
				<p>
					商品原价总金额：<em>{{ totalCheckedPrice.toFixed(2) }}元</em>
				</p>
				<p v-show="hasPaperProduct && shippingCost">
					运费：<em>{{ shippingCost.toFixed(2) }}元</em>
				</p>
				<p v-show="reduceTotal">
					共减：<em>{{ reduceTotal.toFixed(2) }}元</em>
				</p>
			</div>
			<!-- 有额外商品 -->
			<div v-else class="has-extra-goods">
				<p style="margin-bottom: 10px">
					订单总金额：<em style="color: #ff5722; font-size: 20px; font-weight: 600">待确定</em>
				</p>
				<p>
					现有商品总金额：<em>{{ totalChecked.toFixed(2) }}元</em>
				</p>
				<p>
					现有商品原价总金额：<em>{{ totalCheckedPrice.toFixed(2) }}元</em>
				</p>
				<p v-show="hasPaperProduct && shippingCost">
					运费：<em>{{ shippingCost.toFixed(2) }}元</em>
				</p>
				<p v-show="reduceTotal">
					共减：<em>{{ reduceTotal.toFixed(2) }}元</em>
				</p>
				<p style="color: #f97316; font-size: 13px; margin-top: 8px">提示：当前订单中有额外添加的商品，订单金额需要确定</p>
			</div>

			<el-form @submit.native.prevent ref="formRef" :model="formData" label-position="left" size="mini" :rules="rules">
				<el-form-item label="选择支付方式：" style="margin-bottom: 14px; margin-top: 8px">
					<el-radio-group v-model="formData.payType" size="small">
						<el-radio-button :label="0">微信</el-radio-button>
						<el-radio-button :label="1">支付宝</el-radio-button>
						<el-radio-button :label="2">对公转账</el-radio-button>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="是否需要发票：" style="margin-bottom: 14px">
					<el-radio-group v-model="formData.invoiceHad" @change="handleInvoiceHadChange">
						<el-radio :label="0">不需要</el-radio>
						<el-radio :label="1">需要</el-radio>
					</el-radio-group>
				</el-form-item>
				<div v-show="formData.invoiceHad">
					<el-divider content-position="left">发票信息</el-divider>
					<!--					<el-form-item label="发票类型：" style="margin-bottom: 14px" class="invoice-type" prop="invoiceType">-->
					<!--						<el-radio-group v-model="formData.invoiceType" size="mini" @change="handleInvoiceTypeChange">-->
					<!--							<el-radio style="font-size: 12px" v-for="(item, index) in titleTypeList" :key="index" :label="item.value">{{ item.label }}</el-radio>-->
					<!--						</el-radio-group>-->
					<!--					</el-form-item>-->
					<el-form-item label="发票信息：" style="margin-bottom: 24px" v-show="formData.invoiceType == 2" prop="invoiceId">
						<el-select v-model="formData.invoiceId" placeholder="请选择" filterable style="width: 240px">
							<el-option v-for="item in invoiceList" :key="item.id" :label="item.invoiceTitle" :value="item.id" />
						</el-select>
					</el-form-item>
					<el-form-item v-show="formData.invoiceType == 2">
						<el-button icon="el-icon-refresh" type="text" @click="getCorporateGetInvoice" v-click-once style="margin-right: 10px">刷新</el-button>
						<el-button icon="el-icon-add" type="text" @click="handleAddInvoice" v-click-once style="margin-right: 10px">发票管理</el-button>
					</el-form-item>
					<el-form-item label="备注信息：" style="margin-bottom: 24px" v-show="formData.invoiceType == 1">
						<el-input style="width: 240px" v-model.trim="formData.brief" type="textarea" placeholder="填写备注信息（例如：姓名）" maxlength="200" show-word-limit />
					</el-form-item>
				</div>
				<p style="color: #606266; font-size: 13px; font-weight: normal; margin-top: 16px; line-height: 22px">说明：本平台所销售图书由北京品读文化发展有限公司开具增值税普通发票（电子发票）</p>
			</el-form>
			<!-- 是否开发票，选择发票是专票还是普票，再选择发票信息 列表 -->
			<p></p>
		</div>

		<div class="paymentlist" style="text-align: right; margin-top: 30px">
			<el-button v-click-once="3000" :disabled="loading" :loading="loading" type="danger" @click="toSubmit">{{ loading ? '订单提交中' : `提交订单` }} </el-button>
		</div>

		<!-- 支付 -->
		<!-- <WeChatPay ref="WeChatPayRef" :total="orderBasic.totalAmount" :orderNum="orderBasic.tradeNo" />
		<Alipay ref="AlipayRef" :total="orderBasic.totalAmount" :orderNum="orderBasic.tradeNo" />
		<OfflineTransfer ref="OfflineTransferRef" :orderBasic="orderBasic" /> -->
	</el-card>
</template>

<script>
	import Y from '@/utils/Y';
	import { mapState, mapGetters, mapActions } from 'vuex';
	import bus from '@/bus';
	import WeChatPay from '@/components/Pay/WeChatPay.vue';
	import Alipay from '@/components/Pay/Alipay.vue';
	import OfflineTransfer from '@/components/Pay/OfflineTransfer.vue';
	import { getConsumerOrderInfo, postConsumerOrderShippingCost } from '@/api/order/order';
	import { getCorporateGetInvoice } from '@/api/user/invoice';
	import merge from 'webpack-merge';
	export default {
		props: {
			hasPaperProduct: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				// radio: 1,
				loading: false,

				// params: {
				// 	cartInfos: [],
				// 	addressId: null
				// },

				orderBasic: {},
				orderAddress: {},
				orderDetails: [],

				orderId: null,

				//运费
				shippingCost: 0,

				formData: {
					cartInfos: [],
					addressId: null,
					brief: '',
					invoiceHad: 0,
					invoiceType: 2,
					payType: 0,
					invoiceId: null,
					orderType: 1
				},

				invoiceList: [],

				invoiceTypeList: [
					{
						label: '增值税普通发票',
						value: 1
					},
					{
						label: '增值税专用发票',
						value: 2
					}
				],
				titleTypeList: [
					{
						label: '个人',
						value: 1
					},
					{
						label: '企业',
						value: 2
					}
				],
				//如果选择了需要发票，选择个人发票，必须填写备注信息，选择企业发票，必须选择发票信息，否则不能提交
				rules: {
					invoiceType: [{ required: true, message: '请选择发票类型', trigger: 'change' }],
					// brief: [
					// 	{
					// 		required: true,
					// 		message: '个人发票需要填写备注信息',
					// 		trigger: 'blur',
					// 		validator: (rule, value, callback) => {
					// 			if (this.formData.invoiceHad == 1 && this.formData.invoiceType == 1) {
					// 				if (!value || value.trim() === '') {
					// 					callback(new Error('个人发票需要填写备注信息'));
					// 				} else {
					// 					callback();
					// 				}
					// 			} else {
					// 				callback();
					// 			}
					// 		}
					// 	}
					// ],
					invoiceId: [
						{
							required: true,
							message: '企业发票需要选择发票信息',
							trigger: 'change',
							validator: (rule, value, callback) => {
								if (this.formData.invoiceHad == 1 && this.formData.invoiceType == 2) {
									if (!value || value === '') {
										callback(new Error('企业发票需要选择发票信息'));
									} else {
										callback();
									}
								} else {
									callback();
								}
							}
						}
					]
				}
			};
		},
		computed: {
			...mapState('Cart', ['cartNum', 'form', 'cartList', 'hasPaperProduct', 'hasElseProduct']),
			...mapGetters('Cart', ['checkedNum', 'totalNum', 'cartNum', 'total', 'oriTotal', 'reduceTotal', 'totalChecked', 'totalCheckedPrice'])
		},
		components: {
			WeChatPay,
			Alipay,
			OfflineTransfer
		},

		created() {
			if (this.$route.query.orderId) {
				this.getConsumerOrderInfo();
			}
			this.getCorporateGetInvoice();
		},

		methods: {
			// 处理发票类型变化
			handleInvoiceTypeChange() {
				// 重置相关字段
				this.formData.invoiceId = null;
				this.formData.brief = '';
				// 清除验证状态
				this.$nextTick(() => {
					this.$refs.formRef.clearValidate(['invoiceId']);
				});
			},

			// 处理是否需要发票变化
			handleInvoiceHadChange() {
				if (this.formData.invoiceHad == 0) {
					// 如果不需要发票，重置所有发票相关字段
					this.formData.invoiceType = 1;
					this.formData.invoiceId = null;
					this.formData.brief = '';
					// 清除验证状态
					this.$nextTick(() => {
						this.$refs.formRef.clearValidate(['invoiceType', 'invoiceId']);
					});
				}
			},

			handleAddInvoice() {
				const targetRoute = this.$router.resolve({
					path: '/UserCenter/UserInvoice'
				});
				window.open(targetRoute.href, '_blank');
			},

			//获取发票列表
			async getCorporateGetInvoice() {
				const res = await getCorporateGetInvoice({});
				this.invoiceList = res.data.rows;
			},

			//获取订单详情
			getConsumerOrderInfo() {
				this.loading = true;
				getConsumerOrderInfo(this.$route.query.orderId)
					.then(res => {
						const { orderAddress, orderBasic, orderDetails } = res.data;
						this.orderAddress = orderAddress;
						this.orderBasic = orderBasic;
						this.orderDetails = orderDetails;
						this.loading = false;
					})
					.catch(err => {
						this.loading = false;
						Y.msg.error(err.message || '获取订单详情失败');
					});
			},

			handleWeChatPay() {
				if (this.$route.query.orderId) {
					this.$refs.WeChatPayRef.payModal = true;
				} else {
					this.toSubmit(1);
				}
				// 处理微信支付逻辑
			},
			handleAlipay() {
				if (this.$route.query.orderId) {
					this.$refs.AlipayRef.payModal = true;
				} else {
					this.toSubmit(2);
				}
				// 处理支付宝支付逻辑
			},
			handleOfflineTransfer() {
				if (this.$route.query.orderId) {
					this.$refs.OfflineTransferRef.payModal = true;
				} else {
					this.toSubmit(3);
				}
				// 处理线下转账逻辑
			},

			toSubmit(type) {
				if (this.hasPaperProduct && !this.formData.addressId) {
					Y.msg.error('请选择派送地址');
					return;
				}
				// 验证表单
				this.$refs.formRef.validate(valid => {
					if (!valid) {
						Y.msg.error('请完善发票信息');
						return;
					}
					if (this.hasElseProduct) {
						this.$confirm('结算订单中有额外添加的商品，业务员定价之后可统一付款，定价通过需1~3个工作日，是否继续?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						})
							.then(() => {
								this.doSubmit(type);
							})
							.catch(() => {});
					} else {
						this.doSubmit(type);
					}
				});
			},

			//获取运费
			async postConsumerOrderShippingCost() {
				this.formData.cartInfos = [];
				this.cartList.forEach(item => {
					if (item.isSelected) {
						this.formData.cartInfos.push({
							skuId: item.skuId,
							buyNum: item.buyNum,
							spuName: item.spuName
						});
					}
				});
				const res = await postConsumerOrderShippingCost(this.formData);
				if (res.code == 200) {
					this.shippingCost = res.data;
				}
			},

			doSubmit(type) {
				// console.log('该提交了！！！');

				this.loading = true;

				this.formData.corporateGoods = [];

				this.cartList.forEach(item => {
					if (item.isSelected) {
						this.formData.corporateGoods.push({
							skuId: item.skuId,
							buyNum: item.buyNum,
							spuName: item.spuName
						});
					}
				});

				this.$store
					.dispatch('Cart/submitOrder', this.formData)
					.then(res => {
						if (res.code == 200) {
							if (this.hasElseProduct) {
								// Y.msg.warning('本订单有额外添加的商品，审核通过之后');
								//跳转到订单详情
								this.$router.push({ path: '/OrderDet', query: { orderId: res.data } });
							} else {
								if (this.formData.payType == 0) {
									this.$router.push({ path: '/WeChatPay', query: { orderId: res.data, total: this.totalChecked.toFixed(2) } });
								} else if (this.formData.payType == 1) {
									this.$router.push({ path: '/AlipayPay', query: { orderId: res.data, total: this.totalChecked.toFixed(2) } });
								} else if (this.formData.payType == 2) {
									this.$router.push({ path: '/OfflineTransfer', query: { orderId: res.data, total: this.totalChecked.toFixed(2) } });
								}
							}
						}
					})
					.catch(err => {
						this.loading = false;
						Y.msgError(err.message || '提交订单失败');
					});
			}
		},

		mounted() {
			bus.$on('selectAddress', address => {
				this.formData.addressId = address.id;
				if (this.hasPaperProduct) {
					this.postConsumerOrderShippingCost();
				}
			});
		}
	};
</script>
<style lang="less" scoped>
	.pay-detail {
		p {
			margin: 0;
			font-size: 14px;
			color: #333333;
			font-weight: 600;
			display: flex;
			align-items: center;
			justify-content: space-between;
			em {
				font-style: normal;
				font-weight: 400;
			}
		}
	}

	/deep/ .pay-detail .el-form-item__label {
		font-size: 14px;
		color: #333333;
		font-weight: 600;
	}

	/deep/ .pay-detail .el-form-item__content {
		text-align: right;
		margin-left: 100px;
	}

	/deep/ .invoice-type .el-radio {
		// margin-right: 10px;
	}

	/deep/ .pay-detail .el-radio__label {
		font-size: 12px;
	}

	.paymentbox {
		margin-bottom: 20px;
		background-color: #ffffff;
		box-shadow: 0px 3px 7px 0px rgba(0, 122, 255, 0.1);
		border-radius: 15px;
		h3 {
			margin: 0;
			font-weight: 400;
			font-size: 18px;
			color: #333333;
		}
	}
	.paymentlist {
		button + button {
			margin-left: 20px;
		}
	}
	.pay-radio {
		width: 40%;
		height: 46px;
		font-size: 18px;
		color: #333333;
		border-radius: 7px;
	}

	/deep/ .el-card__header {
		padding: 30px 30px 0;
		border-bottom: none;
	}
	/deep/ .el-card__body,
	.el-main {
		padding: 20px 30px 40px;
	}
	//媒体查询-pad
	@media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
		.paymentlist {
			button + button {
				margin-left: 30px;
			}
		}
	}
</style>
